import axios from "../axiosConfig";

// Expenses are sent as multipart so the optional receipt image can ride along.
// axiosConfig sets the multipart Content-Type automatically for FormData.
const toFormData = (payload) => {
  const formData = new FormData();

  Object.entries(payload).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    formData.append(key, value);
  });

  return formData;
};

class ExpenseRoutes {
  createExpense = (payload) => {
    return axios.post("/api/expenses", toFormData(payload));
  };

  getAllExpenses = (filters = {}) => {
    const params = Object.fromEntries(
      Object.entries(filters).filter(([, value]) => value !== undefined && value !== null && value !== "")
    );
    return axios.get("/api/expenses", { params });
  };

  getExpenseById = (id) => {
    return axios.get(`/api/expenses/${id}`);
  };

  getCategories = () => {
    return axios.get("/api/expenses/categories");
  };

  updateExpense = (id, payload) => {
    return axios.put(`/api/expenses/${id}`, toFormData(payload));
  };

  deleteExpense = (id) => {
    return axios.delete(`/api/expenses/${id}`);
  };
}

export default new ExpenseRoutes();
